
  import { defineComponent } from "vue";
  
  export default defineComponent({
    props: {
      object: Object,
    },
    methods: {
      stateName(state: string) {
        if (state?.toLowerCase().trim() == "unreachable") {
          return "injoignable";
        } else if (state?.toLowerCase().trim() == "ok") {
          return "connecté";
        } else {
          return "inconnu";
        }
      },
    }
  });
  